// Auth API tags
export const AUTH_API_TAGS = {
  GET_ME: "get-me",
  AUTH: "auth",
} as const;

// App API tags
export const APP_API_TAGS = {
  // START: Employee Management
  EMPLOYEES: "employees",
  EMPLOYEE_DOCUMENTS: "employee-documents",
  DEPARTMENTS: "departments",
  DESIGNATIONS: "designations",
  // END: Employee Management

  // START: EMP Payroll
  SALARY_GRADE: "salary-grade",
  PAYROLL_BATCH: "payroll-batch",
  SALARY_STRUCTURE: "salary-structure",
  PAYROLL_SALARY_SHEET: "payroll-salary-sheet",
  BONUS_POLICY: "bonus-policy",
  PAYROLL_EMPLOYEES: "payroll-employee",
  PAYROLL_CALENDAR: "payroll-calendar",
  PAYROLL_DAILY_PAY: "payroll-daily-pay",
  // END: EMP Payroll

  // START: Attendance Management
  SHIFTS: "shifts",
  ATTENDANCES: "attendances",
  // END: Attendance Management

  // START: Leave Management
  LEAVES: "leaves",
  HOLIDAYS: "holidays",
  POLICIES: "policies",
  // END: Leave Management

  // START: Organization Management
  CUSTOM_EMPLOYEE_FIELDS: "custom-employee-fields",
  PLANS: "plans",
  OFFICES: "offices",
  INDUSTRIES: "industries",
  ORGANIZATION: "organization",
  SUBSCRIPTIONS: "subscriptions",
  // END: Organization Management

  // START: Control Panel
  ROLES: "roles",
  AUDIT_LOGS: "audit-logs",
  CTRL_PANEL_STATES: "control-panel-states",
  // END: Control Panel

  // START: Reports
  ATTENDANCE_REPORTS: "attendance_generate_reports",
  // END: Reports

  // START: Data Import/Export
  ALL_FAILED_SHIFT: "all-failed-shifts",
  ALL_FAILED_EMPLOYEE: "all-failed-employee",
  // END: Data Import/Export

  // START: Recruitment
  JOB_POSTS: "job-posts",
  JOB_APPLICANTS: "job-applicants",
  SHORTLIST: "shortlist",
  ASSESSMENTS: "assessments",
  TALENT_HUNT_JOB_POSTS: "talent-hunt-job-posts",
  APPLICANT_TALENT_HUNT_JOB: "applicant-talent-hunt-job",
  SYNC_TALENT_HUNT_JOB: "sync-talent-hunt-job",
  INTERVIEWS: "interviews",
  EVALUATED_INTERVIEWS: "evaluated-interviews",
  PENDING_INTERVIEWS: "pending-interviews",
  OFFER_LETTERS: "offer-letters",
  HIRING_PIPELINE: "hiring-pipeline",
  RECRUITMENT_DASHBOARD: "recruitment-dashboard",
  AI_GENERATED_INTERVIEW_QUESTIONS: "ai-generated-interview-questions",
  // END: Recruitment
  // START: Performance
  PERFORMANCE: "performance",
  // END: Performance
} as const;

// User roles
export const USER_ROLES = {
  USER: "user",
  ADMIN: "admin",
  EVALUATOR: "evaluator",
  LINE_MANAGER: "line-manager",
  EVALUATOR_USER: "evaluator-user",
  EVALUATOR_MANAGER: "evaluator-manager",
} as const;

// API tags & role types
export type TAuthApiTags = (typeof AUTH_API_TAGS)[keyof typeof AUTH_API_TAGS];
export type TAppApiTags = (typeof APP_API_TAGS)[keyof typeof APP_API_TAGS];
export type TUserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];
